<!-- Önálló oldalként saját fejléccel; a napló napi ablakába ágyazva (beagyazott) csak a törzs. -->
<ng-container *ngIf="!beagyazott; else torzs">
<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Fogadóóra</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ng-container *ngTemplateOutlet="torzs"></ng-container>
</ion-content>
</ng-container>

<ng-template #torzs>
<div class="fogadoora">
  <div *ngIf="betolt" class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></div>
  <p class="hiba" *ngIf="hiba">{{ hiba }}</p>

  <!-- ===================== TANÁR ===================== -->
  <ng-container *ngIf="mod === 'tanar' && !hiba">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Új fogadóóra</ion-card-title>
        <ion-card-subtitle>A megadott sávot a rendszer a választott időközönként időpontokra osztja; a szülők ezekre foglalhatnak.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-grid class="mezok">
          <ion-row>
            <ion-col size="12" sizeMd="3"><ion-input type="date" label="Nap" label-placement="stacked" [(ngModel)]="uj.datum"></ion-input></ion-col>
            <ion-col size="4" sizeMd="2"><ion-input type="time" label="Mettől" label-placement="stacked" [(ngModel)]="uj.kezdes"></ion-input></ion-col>
            <ion-col size="4" sizeMd="2"><ion-input type="time" label="Meddig" label-placement="stacked" [(ngModel)]="uj.vege"></ion-input></ion-col>
            <ion-col size="4" sizeMd="2"><ion-input type="number" min="5" max="180" label="Időköz (perc)" label-placement="stacked" [(ngModel)]="uj.idokoz_perc"></ion-input></ion-col>
            <ion-col size="12" sizeMd="3"><ion-input label="Hely" label-placement="stacked" placeholder="pl. 12-es terem / Teams" [(ngModel)]="uj.hely" maxlength="200"></ion-input></ion-col>
            <ion-col size="12"><ion-input label="Megjegyzés a szülőknek" label-placement="stacked" [(ngModel)]="uj.megjegyzes" maxlength="1000"></ion-input></ion-col>
          </ion-row>
        </ion-grid>
        <div class="gombok">
          <span class="halvany">{{ ujDarab }} időpont</span>
          <ion-button (click)="meghirdet()" [disabled]="fut || !ujDarab || !uj.datum">
            <ion-icon slot="start" name="megaphone-outline"></ion-icon>{{ fut ? 'Mentés…' : 'Meghirdetés' }}
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>

    <h2 class="cim">Fogadóóráim</h2>
    <p class="halvany" *ngIf="!betolt && !sajat.length">Még nincs meghirdetett fogadóórád.</p>
    <ion-card *ngFor="let f of sajat" [class.torolt]="f.torolve" [class.elmult]="f.elmult">
      <ion-card-header>
        <ion-card-title>{{ napNev(f.datum) }} · {{ f.kezdes }}–{{ f.vege }}</ion-card-title>
        <ion-card-subtitle>
          {{ f.idokoz_perc }} percenként · {{ foglaltDb(f) }}/{{ f.idopontok.length }} foglalt{{ f.hely ? ' · ' + f.hely : '' }}
          <span *ngIf="f.torolve" class="piros"> · LEMONDVA</span>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <table class="lista">
          <thead><tr><th>Időpont</th><th>Tanuló</th><th>Szülő</th><th>Megjegyzés</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let x of f.idopontok" [class.szabad]="!x.foglalas">
              <td>{{ x.ido }}</td>
              <ng-container *ngIf="x.foglalas as g; else szabadSor">
                <td>{{ g.tanulo_nev }}<span class="halvany" *ngIf="g.osztaly"> ({{ g.osztaly }})</span></td>
                <td>{{ g.szulo_nev || g.szulo }}<div class="halvany">{{ g.szulo_telefon }} {{ g.szulo_email }}</div></td>
                <td>{{ g.megjegyzes }}</td>
                <td class="muvelet"><ion-button size="small" fill="clear" color="danger" *ngIf="!f.torolve && !f.elmult" (click)="foglalasLemond(g)">Lemondás</ion-button></td>
              </ng-container>
              <ng-template #szabadSor><td colspan="4" class="halvany">szabad</td></ng-template>
            </tr>
          </tbody>
        </table>
        <p class="halvany" *ngIf="f.lemondott?.length">Lemondott foglalások: {{ f.lemondott.length }}</p>
        <div class="gombok">
          <ion-button size="small" fill="outline" (click)="nyomtat(f)"><ion-icon slot="start" name="print-outline"></ion-icon>Nyomtatás</ion-button>
          <ion-button size="small" fill="outline" (click)="csv(f)"><ion-icon slot="start" name="download-outline"></ion-icon>Letöltés (CSV)</ion-button>
          <ion-button size="small" fill="clear" color="danger" *ngIf="!f.torolve && !f.elmult" (click)="fogadooraLemond(f)">Fogadóóra lemondása</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>

  <!-- ===================== SZÜLŐ ===================== -->
  <ng-container *ngIf="mod === 'szulo' && !hiba">
    <div class="szurok">
      <ion-segment *ngIf="gyermekek.length > 1" [(ngModel)]="gyermek" [scrollable]="true">
        <ion-segment-button *ngFor="let g of gyermekek" [value]="g.oktazon"><ion-label>{{ g.nev }}{{ g.osztaly ? ' (' + g.osztaly + ')' : '' }}</ion-label></ion-segment-button>
      </ion-segment>
      <ion-item lines="none">
        <ion-toggle [(ngModel)]="csakTanarai" justify="start">Csak {{ gyermekek.length > 1 ? 'a kiválasztott gyermek' : 'a gyermekem' }} tanárai</ion-toggle>
      </ion-item>
      <ion-searchbar [(ngModel)]="kereso" placeholder="Tanár neve" [debounce]="150"></ion-searchbar>
    </div>
    <p class="halvany" *ngIf="!betolt && !gyermekek.length">Nincs hozzád rendelt gyermek – fogadóórára nem tudsz foglalni.</p>
    <p class="halvany" *ngIf="!betolt && gyermekek.length && !szurtFogadoorak.length">
      Nincs meghirdetett fogadóóra{{ csakTanarai ? ' a gyermeked tanáraitól – kapcsold ki a szűrést a többi tanárért' : '' }}.
    </p>
    <ion-card *ngFor="let f of szurtFogadoorak">
      <ion-card-header>
        <ion-card-title>{{ f.tanar_nev }}</ion-card-title>
        <ion-card-subtitle>{{ napNev(f.datum) }} · {{ f.kezdes }}–{{ f.vege }}{{ f.hely ? ' · ' + f.hely : '' }}</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p *ngIf="f.megjegyzes" class="halvany">{{ f.megjegyzes }}</p>
        <div class="sajat" *ngFor="let fg of f.sajat_foglalasok">
          <ion-icon name="checkmark-circle"></ion-icon>
          Foglalásod: <b>{{ fg.idopont }}</b> · {{ gyermekNev(fg.oktazon) }}
          <ion-button size="small" fill="clear" color="danger" (click)="lemond(f, fg)">Lemondás</ion-button>
        </div>
        <div class="idopontok">
          <ion-chip *ngFor="let x of f.idopontok" [color]="x.sajat ? 'success' : (x.szabad ? 'primary' : 'medium')"
                    [outline]="x.szabad && !x.sajat" [disabled]="!x.szabad && !x.sajat" (click)="foglal(f, x)">
            {{ x.ido }}
          </ion-chip>
        </div>
        <p class="halvany">Kék: szabad, zöld: a te foglalásod, szürke: foglalt vagy elmúlt.</p>
      </ion-card-content>
    </ion-card>
  </ng-container>
</div>
</ng-template>
